import React from 'react';

import { Warning } from '@trqk/components';

export const UploadErrorMessage = (): JSX.Element => (
    <>
        <div className="border-l-4 border-solid border-quinary-400 rounded-full" />
        <div className="ml-12">
            <Warning>FILE UPLOAD ERROR</Warning>
            <div className="text-white text-3xl pt-3 pb-6">
                Please try again later.
            </div>
        </div>
    </>
);
